module.exports = __webpack_public_path__ + "img/product11.5fab95f0.jpg";